import React, { ReactNode } from 'react'
import { ThemeContext, useThemeProvider } from '../hooks/useTheme'

export default function ThemeProvider({ children }: { children: ReactNode }) {
  const value = useThemeProvider()
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}
